module.exports = __webpack_public_path__ + "static/img/Frame 18219.4987bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 18219.png
// module id = JKBd
// module chunks = 12